import { TerminalStatus, TerminalStatusContext } from '../../../types/mf-execution.types'
import { AllStatusWrapper } from '../../../components/execution/terminal/AllStatusWrapper'
import { getOrdersTabCTA } from '../../../utils/mutualFundDetail'
import { postCTA } from '../../../utils/appBridge'

export const BuyOrderSuccessPage = () => {
  return (
    <div className='w-full h-screen relative overflow-hidden'>
      <AllStatusWrapper
        status={TerminalStatus.FULL_SUCCESS}
        statusContext={TerminalStatusContext.BUY}
        fullSuccessConfig={{
          title: 'Order placed',
          caption: 'Your investment will be processed <br /> within 3-4 working days.',
          ctas: [
            {
              ctaType: 'secondary',
              label: 'Go to dashboard',
              onClick: () => {
                // Handle navigation to dashboard
                console.log('Navigate to orders tab')
                postCTA(JSON.stringify(getOrdersTabCTA()))
              }
            }
          ]
        }}
      />
    </div>
  )
}
